export interface OkResponse<T> {
  status: number;
  message: string | null;
  result: T;
}

export function toursBasePath(): string {
  return `${window.configs.API_HOST}/api/v2/tours`;
}

/** svc-tour keys tours by bare uuid; Admin routes carry `tour-<uuid>`. */
export function stripTourPrefix(tourId: string): string {
  return tourId.replace(/^tour-/, '');
}
